<template>
    <div class="grid-x">
        <div id="product-buttons" class="large-6 cell">
            <div class="grid-x" v-if="buttons">
                <product-button v-for="(button, index) in buttons" :value="button" :key="index" @do-action="handleAction(button.function)" ></product-button>
            </div>
        </div>
        <div id="pricing-grid" class="large-6 cell">
            <form v-if="info" :class="info.buynow ? 'buynow' : ''">
                <div class="grid-x">
                    <div class="cell formtitle"><b>Quick quote</b></div>
                    <div class="small-6 medium-3 large-6 cell"><label for="quote-width" class="middle">Width (m)</label></div>
                    <div class="small-6 medium-3 large-6 cell">
                        <select v-model="chosenwidth" class="entered" @change="dimensionChange">
                            <option v-for="(option,index) in info.widths" v-bind:value="option" >{{ option }}</option>
                        </select>
                    </div>
                    <div class="small-6 medium-3 large-6 cell"><label for="quote-length" class="middle">Length (m)</label></div>
                    <div class="small-6 medium-3 large-6 cell"><input type="number" v-model="chosenlength" mine="0" step=".1" @change="dimensionChange" /></div>
                    <div class="small-6 medium-3 large-6 cell"><span class="name middle">Area (m&sup2;)</span></div>
                    <div class="small-6 medium-3 large-6 cell"><span class="value middle">{{ area }}</span></div>
                    <div class="small-6 medium-3 large-6 cell"><span class="name middle">Cost <span v-html="basket.contents.currency_symbol"></span> <small>({{ info.vattext }})</small></span></div>
                    <div class="small-6 medium-3 large-6 cell"><span class="value middle">{{ cost  }}</span></div>
                </div>
                <button v-if="info.buynow" href="#" class="buy" @click="buycarpet">Buy Me</button>
            </form> 
        </div>
        <div class="reveal alternativeModal" id="errorModal" data-reveal data-animation-in="fade">
            <div class="paint-button error grid-x" style="height:250px;width:250px; padding-top:3.5rem;">
                <div v-html="errortext" class="text-center"></div>
                <button class="close error" data-close aria-label="Close modal" type="button">OK</button>
            </div>
        </div>
    </div>        
</template>
<script setup>
    import { onMounted, ref, inject, watch } from 'vue'
    import { useBasketStore } from '@/stores/basket'
    import RendiliCore from '@RendiliCore'
    import productButton from './product-button.vue'

    const code = inject('code')
    const basket = useBasketStore()
    const buttons = ref(null)
    //buttons: productButtons,
    const info = ref(null)
    const chosenwidth = ref(null)
    const chosenlength = ref(null)
    const area = ref('')
    const cost = ref('')
    const errortext = ref('')

    function getoptions() {
        RendiliCore.Json.Get("/alternative/product/options/" + code)
            .then(function(data) {
                buttons.value = data.buttons
                info.value = data.options
                data.options.widths.length ? chosenwidth.value = data.options.widths[0] : ''
            })
    }

    function calculate() {
        if (chosenlength.value < 0) {
            chosenlength.value = 0
            return
        }
        if (chosenwidth.value && chosenlength.value) {
            RendiliCore.Json.PostJsonData({
                    url: "/alternative/product/calculate",
                    method: 'POST',
                    data: {
                        code: code,
                        width: chosenwidth.value,
                        length: chosenlength.value
                    }
                })
                .then(function(data) {
                    if (data.error) {
                        area.value = ''
                        cost.value = ''
                        errortext.value = data.error
                        $('#errorModal').foundation('open')
                    } else {
                        area.value = data.area
                        cost.value = data.cost
                    }
                })
        } else {
            errortext.value = "Oops! We just need you to enter your required width and length in the<br />'Quick quote' box"
            $('#errorModal').foundation('open')
        }
    }

    function updatewishlist() {
        $('.mini-wishlist-holder').removeClass('hide')
        $('a.wishlist').addClass('on')
        window.scrollTo(0, 0)
    }

    function addwishlist() {
        if (parseInt(cost).value > 0) {
            //add the carpet
            RendiliCore.Json.PostJsonData({
                    url: "/wishlist/add/1",
                    data: {
                        type: 'carpet',
                        productcode: code,
                        code: code + '-' + chosenlength.value + '-' + chosenwidth.value
                    }
                })
                .then(function() {
                    updatewishlist()
                })
        } else {
            //add sample
            RendiliCore.Json.PostJsonData({
                    url: "/wishlist/add/1",
                    data: {
                        code: code,
                        type: 'swatch'
                    }
                })
                .then(function() {
                    updatewishlist()
                })
        }
    }

    function buycarpet(event) {
        if (event) {
            event.preventDefault()
        }
        calculate()
        if (cost.value) {
            basket.addCarpet(code, chosenwidth.value, chosenlength.value)
        }
    }

    function showExclusivePopup() {
        errortext.value = 'Our Web Exclusives are made to order and there is a minimum order quantity.<br>We can make rugs and runners from these designs, simply <a href="/where-to-buy?type=play-partner">contact your local Retail Partner</a> to find out more.'
        $('#errorModal').foundation('open')
    }

    function handleAction(fn) {
        switch (fn) {
            case 'addsample':
                basket.addSample(code)
                break
            case 'addwishlist':
                addwishlist()
                break
            case 'buycarpet':
                buycarpet()
                break
            case 'showExclusivePopup':
                showExclusivePopup()
                break
        }
    }

    watch(chosenwidth, () => {
        if (chosenlength.value && chosenwidth.value) {
            calculate()
        } else {
            area.value = ''
            cost.value = ''
        }
    })

    watch(chosenlength, () => {
        if (chosenlength.value && chosenwidth.value) {
            calculate()
        } else {
            area.value = ''
            cost.value = ''
        }
    })

    onMounted(() => {
        getoptions()
    })

    defineOptions({
        name: 'Product Options'
    })
</script>